/* eslint-disable no-unused-vars */
import axios from "../../axios";
import Role from "@/config/Role";

const urlAppNotificationStatus = "/app-notifications-status";

const state = {
  bells: [],
  notifications: [],
  pagination: {
    current_page: 1,
    per_page: 50,
    total: 0,
  },
};

const actions = {
  async getBells({ commit }, query) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/app-notifications?${new URLSearchParams(query)}`)
        .then((response) => {
          resolve(response);
          commit("SET_BELL_NOTIFICATION", response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Get list Log
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getAppNotifications({ commit }, query) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/app-notifications?${new URLSearchParams(query)}`)
        .then((response) => {
          resolve(response);
          commit("SET_LIST_NOTIFICATION", response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setStatusReading({ commit }, id) {
    return axios.put(`${urlAppNotificationStatus + "/" + id}`);
  },
  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_NOTIFICATION(state, data) {
    let dataMapping = [];
    data.items.forEach((item, index) => {
      dataMapping.push({
        id: item.id,
        user_id: item.user_id,
        index: index,
        title: item.title,
        status: item.status,
        msg: item.description,
        icon: "MessageSquareIcon",
        time: new Date(item.created_at),
        created_at: item.created_at,
        category: "primary",
        content: item.content,
        context: item.context,
        is_student: item.user?.role_id === Role.USER_ROLE_STUDENT,
      });
    });
    state.notifications = dataMapping;
    state.pagination = data.pagination;
  },
  SET_BELL_NOTIFICATION(state, data) {
    let dataMapping = [];
    data.items.forEach((item, index) => {
      dataMapping.push({
        id: item.id,
        user_id: item.user_id,
        index: index,
        title: item.title,
        status: item.status,
        msg: item.description,
        icon: "MessageSquareIcon",
        time: new Date(item.created_at),
        created_at: item.created_at,
        category: "primary",
        content: item.content,
        context: item.context,
        is_student: item.user?.role_id === Role.USER_ROLE_STUDENT,
      });
    });
    state.bells = dataMapping;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
